import { GridColDef, GridColumnHeaderParams, GridRenderCellParams } from "@mui/x-data-grid"
import { useState } from "react"
import { BLACK, PRIMARY } from "../../../ui/Colors"
import { PrimaryText, SecondaryText } from "../../../ui/Text"
import React from "react"
import { Grid } from "@mui/material"
import { SpecificChip } from "../../../ui/SpecificChip"
import MoreVertIcon from '@mui/icons-material/MoreVert'
import { ActionMenu } from "../../../ui/ActionMenu"
import { ModifyArticlesMenu } from "./ModifyArticles"
import { Article } from "../../../../redux/supportAndGuides/supportArticlesType"

export const ArticlesDataGridColumns = (): GridColDef[] => {
    const [open, setOpen] = useState<boolean>(false)
    const [anchorEl, setAnchorEl] = useState(null)
    const [fieldSelected, setFieldSelected] = useState<Article | undefined>()

    const handleClick = (e: React.MouseEvent, value: any) => {
        e.stopPropagation()
        e.preventDefault()
        if (open) {
            setAnchorEl(null)
            setOpen(false)
            setFieldSelected(null)
        } else {
            setAnchorEl(e.currentTarget)
            setOpen(true)
            setFieldSelected(value)
        }
    }
    return [
        {
            field: 'title',
            headerName: 'Titre',
            flex: 0.5,
            editable: false,
            renderHeader: (params: GridColumnHeaderParams) => {

                return (
                    <PrimaryText color={BLACK}>
                        {params.colDef.headerName}
                    </PrimaryText>
                )
            },
            renderCell: (params: GridRenderCellParams) => {
                return (
                    <SecondaryText style={{ fontSize: "1.7vmin" }} color={BLACK}>{params.value}</SecondaryText>
                )
            },
        },
        {
            field: 'description',
            headerName: 'Description',
            flex: 1,
            editable: false,
            renderHeader: (params: GridColumnHeaderParams) => {

                return (
                    <PrimaryText color={BLACK}>
                        {params.colDef.headerName}
                    </PrimaryText>
                )
            },
            renderCell: (params: GridRenderCellParams) => {
                return (
                    <SecondaryText style={{ fontSize: "1.7vmin" }} color={BLACK}>{params.value}</SecondaryText>
                )
            },
        },
        {
            field: 'section',
            headerName: 'Rubrique',
            flex: 0.5,
            editable: false,
            renderHeader: (params: GridColumnHeaderParams) => {
                return (
                    <PrimaryText color={BLACK}>
                        {params.colDef.headerName}
                    </PrimaryText>
                )
            },
            renderCell: (params: GridRenderCellParams) => {
                return (
                    <Grid container
                        p={2}
                        sx={{
                            justifyContent: 'flex-start'
                        }}>
                        <Grid p={0.1} >
                            <SpecificChip
                                pointer={false}
                                label={params.value}
                                color={PRIMARY}
                            />
                        </Grid>
                    </Grid>

                )
            },
        },
        {
            field: 'link',
            headerName: 'Lien',
            flex: 1,
            editable: false,
            renderHeader: (params: GridColumnHeaderParams) => {

                return (
                    <PrimaryText color={BLACK}>
                        {params.colDef.headerName}
                    </PrimaryText>
                )
            },
            renderCell: (params: GridRenderCellParams) => {
                return (
                    <SecondaryText style={{ fontSize: "1.7vmin" }} color={BLACK}>{params.value}</SecondaryText>
                )
            },
        },
        {
            field: 'BUList',
            headerName: 'BU',
            flex: 0.5,
            editable: false,
            renderHeader: (params: GridColumnHeaderParams) => {
                return (
                    <PrimaryText color={BLACK}>
                        {params.colDef.headerName}
                    </PrimaryText>
                )
            },
            renderCell: (params: GridRenderCellParams) => {
                return (
                    <Grid container
                        p={2}
                        sx={{
                            justifyContent: 'flex-start'
                        }}>{params.value.map((el: string) => <Grid key={el} p={0.1} >
                            <SpecificChip
                                pointer={false}
                                label={el}
                                color={PRIMARY}
                            />
                        </Grid>)}
                    </Grid>

                )
            },
        },
        {
            field: 'image',
            headerName: 'Nom de l\'image',
            flex: 1,
            editable: false,
            renderHeader: (params: GridColumnHeaderParams) => {

                return (
                    <PrimaryText color={BLACK}>
                        {params.colDef.headerName}
                    </PrimaryText>
                )
            },
            renderCell: (params: GridRenderCellParams) => {
                return (
                    <SecondaryText style={{ fontSize: "1.7vmin" }} color={BLACK}>{params.value}</SecondaryText>
                )
            },
        },
        {
            field: 'action',
            headerName: 'Actions',
            flex: 0.2,
            editable: false,
            renderHeader: (params: GridColumnHeaderParams) => {
                return (
                    <PrimaryText color={BLACK}>
                        {params.colDef.headerName}
                    </PrimaryText>
                )
            },
            renderCell: (params: GridRenderCellParams) => {
                return (
                    <Grid>
                        <MoreVertIcon id="MoreIcon" sx={{ color: BLACK, cursor: 'pointer' }} onClick={(e) => handleClick(e, params.row)} />
                        <ActionMenu
                            open={open}
                            anchorEl={anchorEl}
                            onClose={(e) => {
                                handleClick(e, params.row)
                            }}
                            children={<ModifyArticlesMenu values={fieldSelected} closeMenu={setOpen}></ModifyArticlesMenu>}
                        />
                    </Grid>)
            },

        },
    ]
}